import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { getToken, getDetectToken } from '@/utils/auth'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url

  //timeout: 15000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['Access-Control-Allow-Headers'] = '*'
    config.headers['Access-Control-Allow-Origin'] = '*'
    if (isContains(config.url, '/smart/health/api/dcs')) {
      config.headers['detecttoken'] = getDetectToken();
      // config.headers['detecttoken'] = '123456'
    } else {
      config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }

    const urlArr = [
      "smart/health/api/dcs",
      "smart/health/api/mds",
      "smart/health/api/medicine",
      "smart/health/api/mental",
      "smart/health/api/questionnaire",
    ]
    const isHaveUrl = urlArr.some(url => {
      return config.url.includes(url);
    })
    if (isHaveUrl) {
      config.headers['detecttoken'] = getDetectToken();
    } else {
      config.headers['Authorization'] = getToken();
    }



    // config.headers['detecttoken'] = '123456'
    // config.withCredentials=true;
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

function isContains(str, substr) {
  return new RegExp(substr).test(str);
}

service.installed = false

//发json
service.json = function (url, params) {
  return new Promise((resolve, reject) => {
    service.post(url, JSON.stringify(params), {
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err)
      })
  });
}


//图片上传
service.upload = function (url, params) {
  return new Promise((resolve, reject) => {
    service.post(url, params)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err)
      })
  });
}


service.install = function (Vue) {

  if (service.installed) return
  Vue.prototype.$service = {}

  Vue.prototype.$service = service;

}

// respone拦截器
service.interceptors.response.use(
  response => {
    // 导出
    const headers = response.headers
    if (headers['content-type'] === 'application/x-download;charset=UTF-8') {
      return response.data
    }
    /**
     * code为非200是抛错 可结合自己业务进行修改
     */
    const res = response.data
    const contentType = response.headers['content-type'] || '';
    if (res.code !== 200 && contentType !== 'application/vnd.ms-excel;charset=utf-8') {
      console.log(contentType);
      let errMsg = res.body.errMsg || res.msg;

      if (res.code === 411) {
        Message({
          message: "账号登录已过期，请重新登录",
          type: 'warning',
          duration: 3 * 1000
        })
        return Promise.reject('error')
      }

      // 401:未登录;
      if (res.code === 401) {
        MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('FedLogOut').then(() => {
            location.reload()// 为了重新实例化vue-router对象 避免bug
          })
        })
        return Promise.reject('error')
      }

      // 如果配置了 silent，则不弹出错误提示
      if (!response.config.silent) {
        Message({
          message: errMsg,
          type: 'error',
          duration: 3 * 1000
        })
      }

      return Promise.reject(new Error(errMsg || 'error'))
    } else {
      return response.data
    }
  },
  error => {
    /*console.log('err' + error)// for debug*/
    /*Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    })*/
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js